<div class="square-image-upload-container">
    <div class="upload-wrapper"
         [class.has-image]="previewUrl"
         [class.dragging]="isDragging"
         [class.editable]="editable"
         (click)="openFileSelector()"
         (dragover)="onDragOver($event)"
         (dragleave)="onDragLeave($event)"
         (drop)="onDrop($event)">
        
        <!-- Preview da Imagem -->
        <div *ngIf="previewUrl" class="image-preview" [style.background-image]="'url(' + previewUrl + ')'">
        </div>
        
        <!-- Placeholder quando não há imagem -->
        <div *ngIf="!previewUrl" class="upload-placeholder">
            <mat-icon class="upload-icon">upload</mat-icon>
            <div class="upload-text" *ngIf="editable">
                Clique ou arraste uma imagem
            </div>
        </div>

        <!-- Botões de ação -->
        <div class="action-buttons" *ngIf="previewUrl && editable">
            <button type="button" 
                    class="action-btn edit-btn" 
                    (click)="openFileSelector(); $event.stopPropagation()"
                    matTooltip="Editar imagem">
                <mat-icon>edit</mat-icon>
            </button>
            
            <button type="button" 
                    *ngIf="excludable"
                    class="action-btn delete-btn" 
                    (click)="deleteImage(); $event.stopPropagation()"
                    matTooltip="Excluir imagem">
                <mat-icon>delete</mat-icon>
            </button>
        </div>
    </div>

    <!-- Input file oculto -->
    <input #fileInput
           type="file"
           hidden
           accept="image/png, image/jpeg"
           (change)="onFileSelected($event)">

    <!-- Hints informativos -->
    <div class="image-hints">
        <div class="hint-item">
            <mat-icon class="hint-icon">info</mat-icon>
            <span>Formatos: JPEG ou PNG</span>
        </div>
        <div class="hint-item">Tamanho máximo: 5MB</div>
        <div class="hint-item">Dimensões ideais: 520x520px</div>
    </div>
</div>
